import GrantAccessesRepository from 'repositories/Profile/GrantAccessesRepository';

const grantAccessToProfile = (profilelId) => GrantAccessesRepository.create(profilelId);

export default () => ({ grantAccessToProfile });
